import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink/PlainButtonOrLink';
import useMaxAttachmentsAllowed from '../../../hooks/useMaxAttachmentsAllowed';

import s from './AttachmentsCounter.scss';

interface Props {
  deviation: PapiDeviation;
}

const AttachmentsCounter: React.FC<Props> = ({ deviation }) => {
  const { t } = useTranslation();
  const { hasCoreMembership } = useContext(SessionContext);
  const maxAttachmentsAllowed = useMaxAttachmentsAllowed();

  const attachments = deviation.extended?.additionalMedia || [];
  const attachmentsCount = (attachments || []).length;

  return (
    <div className={s['root']}>
      <span className={s['count']}>
        {attachmentsCount + 1}/{maxAttachmentsAllowed + 1} images
      </span>
      <SimpleTooltip
        aria-label={t('common.learnMore')}
        text={t(
          hasCoreMembership
            ? 'deviationSubmit.form.manageImages.tooltip.core'
            : 'deviationSubmit.form.manageImages.tooltip.nonCore',
          {
            postProcess: 'reactPostprocessor',
            learnMoreLink: (
              <PlainButtonOrLink
                href={t('deviationSubmit.form.manageImages.tooltip.link')}
                target="_blank"
                className={s['learn-more']}
              >
                {t('common.learnMore')}
              </PlainButtonOrLink>
            ),
          }
        )}
        usePortal
      >
        <InfoIcon size={IconSize.SMALLER} disableDefaultColors />
      </SimpleTooltip>
    </div>
  );
};
AttachmentsCounter.displayName = 'AttachmentsCounter';

export default AttachmentsCounter;
